<template>
	<span v-if="channel.data.text">{{ channel.data.text }}</span>
	<table v-else class="channel-list">
		<thead>
			<tr>
				<th class="channel">Канал</th>
				<th class="users">Мобки</th>
				<th class="topic">Топик</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="chan in channel.data" :key="chan.channel">
				<td class="channel">
					<button class="channel-list-join" @click="joinChannel(chan.channel)">
						<ParsedMessage :network="network" :text="chan.channel" />
					</button>
				</td>
				<td class="users">{{ chan.num_users }}</td>
				<td class="topic"><ParsedMessage :network="network" :text="chan.topic" /></td>
			</tr>
		</tbody>
	</table>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {ClientChan, ClientNetwork} from "../../js/types";
import ParsedMessage from "../ParsedMessage.vue";
import socket from "../../js/socket";
import {switchToChannel} from "../../js/router";
import {useStore} from "../../js/store";

export default defineComponent({
	name: "ListChannels",
	components: {
		ParsedMessage,
	},
	props: {
		network: {type: Object as PropType<ClientNetwork>, required: true},
		channel: {type: Object as PropType<ClientChan>, required: true},
	},
	setup(props) {
		const store = useStore();

		// ЛАФЧЕ.ORG: клик на име на канал в списъка (топ 30/пълния списък) вече
		// влиза директно - ако вече си в канала, само превключва; ако не,
		// изпраща /join
		const joinChannel = (chanName: string) => {
			const existing = props.network.channels.find((c) => c.name === chanName);

			if (existing) {
				switchToChannel(existing);
				return;
			}

			if (store.state.activeChannel) {
				socket.emit("input", {
					target: store.state.activeChannel.channel.id,
					text: "/join " + chanName,
				});
			}
		};

		return {
			joinChannel,
		};
	},
});
</script>
